import { Button, Col, Layout, Row } from 'antd';
import React, { useEffect, useState } from 'react'
import HeaderFile from './Layout/HeaderFile';
import FooterFile from './Layout/FooterFile';
import SmoothScrollProvider from './Layout/SmoothScrollProvider';
import BlurText from './Layout/BlurText';
import VideoGallery from './Layout/VideoGallery';

const { Header, Content, Footer } = Layout;

const About = () => {

    const [isMobile, setIsMobile] = useState(window.innerWidth);
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 770); // Set breakpoint for mobile
      };
  
      handleResize(); // Set initial state
      window.addEventListener("resize", handleResize);
  
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);


  return (
    <Layout>
      <SmoothScrollProvider/>

    <Header className='header-style' >
      {/* Importing from the another component */}
      <HeaderFile/>
    </Header>

    <Content>
        
       <div className='banner-tp'>
          <img src="/about_banner.webp" />
                     <div className="banner-content">
                        <img 
                          src="/frameImg.png"
                          alt=""
                          className='top-img'
                        />
                      <div className="image-content-dis">
            <BlurText
              text="Rucksack Diaries"
              delay={150}
              animateBy="words"
              direction="top"
              className="toptextone"  // example (if using Tailwind)
            />
            <BlurText
              text="Ordinary People. Extraordinary Journeys."
              delay={300}
              animateBy="words"
              direction="top"            
            />
                     </div>
                     </div>             
                  </div>

                    <div className='contbfr' style={{ backgroundColor:"white"}}>
                    
<Row
  className="work_tp_wrap contbfr"
  justify="center"
  align="middle"
  style={{
    padding: isMobile ? "6% 5%" : "5% 6%",
    background: "#fff",
  }}
>
  <Col>
    <p style={{ fontSize: isMobile ? "14px" : "28px", margin: "0" }}>
      Know us
    </p>

    <h1 className="headings">
      What is Rucksack Diaries all about?
    </h1>

    {/* CHAT SECTION */}

    <div className="chatWrap">

      <div className="chatBubble left">
        “Why do you have 37 tabs open?” 
        
      </div>

      <div className="chatBubble right">
        “Don’t touch anything!” Mouna giggled, as if it was sacred.
        “That’s my research for the next trip.”
      </div>

      <div className="chatBubble left">
        “Research? It looks like you've accidentally opened the entire
        internet.”
      </div>

      <div className="chatBubble right">
        “Exactly. Because nobody has put all the information in one
        place!”
      </div>

    </div>

    {/* CONTENT */}

    <p className="contentAbt contentTopM">
     Soon after, Rucksack Diaries was born in 2012, a place to document the journey and its process, partly to remember them and partly so the next traveller wouldn't have to go through the same struggle. 
    </p>

    <p className="contentAbt">
      2 souls, Mouna and Shyam stand at the core of this brand. Our Founder Mouna Nanaiah has a talent for daydreaming, a dreamer who turned her passion for exploration into a way of life. She is a travel vlogger, a motorcyclist, a public speaker and a full time HR Professional. Mouna's partner in life and business, Shyam Gopalakrishna, is also a full time IT Engineer, extremely skilled at understanding the language of motorcycles, and is the backbone of the brand.
    </p>

    <p className="contentAbt">
     Mouna and Shyam, are also avid motorcyclists who deeply love the open road and long distance riding. Together, they have covered close to 1.5 lakh kilometres on motorcycles, balancing their passion for motorcycling alongside full time careers. Their journeys have now expanded internationally, on motorcycles, exploring one country at a time through its roads, landscapes, and people. Bhutan, Cambodia, Laos, and Sri Lanka are a few of the countries they have explored so far, each ride adding a new chapter to their story of adventure and connection.
    </p>

    <p className="contentAbt">
      But Rucksack Diaries is not just about travel blogs or motorcycle rides. It is about finding meaningful experiences, building deeper connections, and creating memories that leave an impact. Through this platform, they are building a community of like minded individuals who believe in responsible travel, adventure, and human connection. Mouna and Shyam are strong evangelists of safe riding and hope to create a positive impact in the world through their rides, storytelling, and initiatives.
    </p>

    <p className="contentAbt">
      Over the years, their honest storytelling, detailed guides, and real experiences have helped people plan trips, take spontaneous adventures, and travel with more confidence and meaning. Rucksack Diaries was born out of this passion for sharing stories that go beyond destinations and itineraries.This space was created for dreamers, riders, travellers, storytellers, and anyone seeking experiences beyond the ordinary. 
    </p>

    <p className="contentAbt">
      If our journey resonates with you, we invite you to join our growing community and become a part of the Rucksack Diaries story.
    </p>
  </Col>
</Row>



       <div
          style={{
            backgroundImage: "url('/S-divider.png')",
            backgroundSize: "contain",            
            backgroundRepeat: "no-repeat",           
            padding: "0 5%",            
            backgroundColor:"white"
          }}
        >
        <Row justify="center" align="middle" style={{padding: isMobile ? "3rem 0 2rem 0" : "5rem 0 4rem 0", }}>
            
            <Col span={isMobile ? 14 : 14} style={{display:"flex", justifyContent:"center"}}>
            <img
                src="/Speaker.png"
                alt="speaker"
                style={{ width: isMobile ? "100%" : "75%", marginTop: isMobile ? 0 : "3rem"}}
              />
            </Col>
        </Row>
        </div>
       </div>




     
          <div justify="center" align="middle" style={{padding: isMobile ? "3% 5%" : "0% 6%", background:"#fff"}}>
             <VideoGallery />
             </div>
        
           
           

       

       
    </Content>

    <Footer style={{ position: 'relative', overflow: 'hidden' }}>

        <FooterFile/>
      </Footer>
    </Layout>
  )
}

export default About